export default {
    file: {
        maxSizeInBytes: 524288000,
        megaByteInBytes: 1048576,
        // Allowed file extensions for upload. Based on the app settings in infrastructure main.tf
        allowedFileExtensions: ['mp4', 'mp3', 'wma', 'mpg', 'avi', 'gif', 'jpeg', 'tif', 'tiff', 'tga', 'png', 'txt', 'pdf', 'ppt', 'pptx', 'doc', 'rtf', 'docx', 'xls', 'xlsx', 'csv', 'zip', 'rar', 'mov', 'jpg', 'webp', 'odt', 'svg', 'msg', 'm4a', 'eml', 'url', 'htm', 'html', 'json', 'xml', 'heic', 'wmv', 'rpt', 'md']
    }
};
